import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AuthService } from 'modules/core/services/auth.service';
import { CurrentUser } from 'modules/shared/models/account.models';
import { SearchType } from 'modules/shared/models/screening.models';

import { AppState } from 'store/root-reducer';
import * as AuthActions from 'store/actions/auth.actions';

import { environment } from 'environment/environment';

@Component({
  selector: 'artemis-dow-jones2-detail',
  templateUrl: './dow-jones2-detail.component.html',
  styleUrls: ['./dow-jones2-detail.component.scss']
})
export class DowJones2DetailComponent implements OnInit {

  private _apiBase: string = environment.API_BASE;
  private _currentToken: string;
  dj2DetailData: any;
  recordType: string;
  isShowSection: any =  {
    isShowPreviousRoles: false,
    iShowPrimaryOccupation: false,
    isShowOtherRoles: false,
    isShowDowJonesComment: false
  };
  constructor(private dialogRef: MatDialogRef<any>,
              private authService: AuthService,
              private store: Store<AppState>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    const data = _.cloneDeep(this.data);
    if (data) {
      this.recordType = this.data.recordType;
      if (data.searchResponse) {
        data.searchResponse.person_name_details = _.groupBy(data.searchResponse.person_name_details, 'name-type');
      }
      this.dj2DetailData = data;

      this.authService.getUser(true)
      .pipe(
        map((user: CurrentUser) => user),
        catchError((err: any) => {
          if (err === 'NotAuthenticated') {
            this.store.dispatch(new AuthActions.LogOut({ isSessionTimeOut: false }));
            return of(null);
          } else {
            return throwError(err);
          }
        })
      )
      .subscribe((user: any) => {
        if (user) {
          this._currentToken = user.signInUserSession.accessToken.jwtToken;
        }
      });

      this.handleShowSection(data);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  convertUrlWithAscensionNumber(url: string): string {
    const textSearch = '(AN=';
    const isExistAN = url.includes(textSearch);
    const urlDefault = 'https://global.factiva.com/redir/default.aspx?P=sa&AN=';
    if (isExistAN) {
      let indexOfAN = url.indexOf(textSearch);
      let lengthUrl = url.length;
      url = urlDefault + url.slice(indexOfAN += 4, lengthUrl -= 1);
    }
    return url;
  }

  isTextValid(str: string): boolean {
    const isUrl = str.includes('http');
    const textSearch = '(AN=';
    const isExistAN = str.includes(textSearch);
    if (isUrl || isExistAN) {
      return true;
    } else {
      return false;
    }
  }

  downloadPDF() {
    // tslint:disable-next-line:max-line-length
    window.location.href = `${this._apiBase}/api/pdfs/${this.data.scanType === SearchType.QUICKSCAN  ? 'quickscan/' : ''}dow_jones2/${this.dj2DetailData.id}/?authorization=${this._currentToken}`;
  }

  handleShowSection(dataDJ2: any) {
    if (dataDJ2 && dataDJ2.searchResponse) {
      if (dataDJ2.searchResponse.watchlist_content && dataDJ2.searchResponse.watchlist_content['role-details']
          && (dataDJ2.searchResponse.watchlist_content['role-details'].length >= 1)) {
        dataDJ2.searchResponse.watchlist_content['role-details'].forEach(roleDetail => {
          if (roleDetail['role-type'] === 'Previous Roles') {
            this.isShowSection.isShowPreviousRoles = true;
          }
          if (roleDetail['role-type'] === 'Primary Occupation') {
            this.isShowSection.iShowPrimaryOccupation = true;
          }
          if (roleDetail['role-type'] !== 'Primary Occupation' && roleDetail['role-type'] !== 'Previous Roles') {
            this.isShowSection.isShowOtherRoles = true;
          }
        });
      }

      if (dataDJ2.searchResponse['adverse-media-content'] && dataDJ2.searchResponse['adverse-media-content']['adverse-media-details']
          && ( dataDJ2.searchResponse['adverse-media-content']['adverse-media-details'].length > 0)) {
        dataDJ2.searchResponse['adverse-media-content']['adverse-media-details'].forEach(adverseMediaDetail => {
          if (adverseMediaDetail['dowjones-comment']) {
            this.isShowSection.isShowDowJonesComment = true;
          }
        });
      }
    }
  }
}
